import React from 'react';
import { useTranslation } from 'react-i18next';
import { WorkspacePremium } from '@mui/icons-material';
import { canShowPremiumUpsell } from '../utils/proPremiumUpsell';
import './ProSidebarPlanCta.css';

export type ProSidebarPlanCtaProps = {
  isPremium: boolean | undefined;
  onUpgrade: () => void;
};

/** Mention de formule, sous le logo. Le bouton d’upgrade reste à part. */
export function ProSidebarPlanStatus({ isPremium }: { isPremium: boolean | undefined }) {
  const { t } = useTranslation('sidebar');
  const premium = Boolean(isPremium);

  return (
    <span
      className="sidebar-plan-status"
      data-rtt-sidebar-plan={premium ? 'premium' : 'essential'}
    >
      {premium ? t('plan.premiumBadge') : t('plan.essentialLabel')}
    </span>
  );
}

const ProSidebarPlanCta: React.FC<ProSidebarPlanCtaProps> = ({ isPremium, onUpgrade }) => {
  const { t } = useTranslation('sidebar');

  if (!canShowPremiumUpsell(isPremium)) return null;

  return (
    <div className="sidebar-plan-cta" data-rtt-sidebar-plan="essential-upsell">
      <button
        type="button"
        className="sidebar-plan-cta__upgrade"
        data-rtt-sidebar-premium-cta="true"
        onClick={onUpgrade}
        aria-label={t('plan.upgradeAria')}
      >
        <WorkspacePremium className="sidebar-plan-cta__upgrade-icon" aria-hidden />
        <span>{t('plan.upgradeCta')}</span>
      </button>
    </div>
  );
};

export default ProSidebarPlanCta;
